import Topnavbar from "../../../Layouts/Topnavbar";
import { Container, Grid, Paper, Text, Title, Group, ThemeIcon, Button, Drawer } from "@mantine/core";
import React, { useState, useEffect } from "react";
import {
    Table,
    Tag,
    Typography,
    Row,
    Col,
    DatePicker,
    Select,
    Input,
    Space,
    Card, message, Descriptions, Divider,
} from "antd";
import dayjs from "dayjs";
import { Userauthcontexthooks } from "../../../Hooks/Userauthcontexthooks";
import { Get_user_ledger } from "../../../apicall";
const { Search } = Input;
const { RangePicker } = DatePicker;






const Adminselfledger = ({ Headername }) => {
    const today = dayjs();
    const [dateRange, setDateRange] = useState([
        today.startOf("day"),
        today.endOf("day"),
    ]);
    const { user } = Userauthcontexthooks();
    const [ledgerloading, setledgerloading] = useState(true);
    const [allLedgerReq, setallLedgerReq] = useState([]);
    const [transactionType, setTransactionType] = useState("ALL");
    const [status, setStatus] = useState("ALL"); // CREDIT / DEBIT
    const [searchTxn, setSearchTxn] = useState("");
    const [ledgerReq, setLedgerreq] = useState([]);
    const [ledgerDrawer, setLedgerDrawer] = useState(false);
    const [selectedLedger, setSelectedLedger] = useState(null);

    const handleSearch = () => {

        let filtered = [...allLedgerReq];

        // Transaction Type
        if (transactionType !== "ALL") {
            filtered = filtered.filter(
                item => item.transactionType === transactionType
            );
        }

        // Credit / Debit
        if (status !== "ALL") {
            filtered = filtered.filter(
                item => item.entryType === status
            );
        }

        // TXN ID Search
        if (searchTxn.trim()) {
            filtered = filtered.filter(item =>
                item.transactionId
                    .toLowerCase()
                    .includes(searchTxn.toLowerCase())
            );
        }

        setLedgerreq(filtered);
    };

    const handleReset = () => {

        setTransactionType("ALL");
        setStatus("ALL");
        setSearchTxn("");

        setLedgerreq(allLedgerReq);
    };

    const fetchuserledger = async () => {

        try {
            const data = await Get_user_ledger(
                dateRange[0].format("YYYY-MM-DD"),
                dateRange[1].format("YYYY-MM-DD")
            );

            if (data.success) {
                console.log(data);
                setallLedgerReq(data?.userLedger);
                setLedgerreq(data?.userLedger);
            }
        } catch (error) {

            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );
        } finally {
            setledgerloading(false);
        }

    }
    const columns = [
        {
            title: "S.No.",
            width: 55,
            render: (_, __, index) => index + 1,
        },

        {
            title: "Txn ID",
            dataIndex: "transactionId",
            width: 150,
            render: (id) => <Text copyable>{id}</Text>,
        },

        {
            title: "Type",
            dataIndex: "transactionType",
            width: 120,
            render: (type) => (
                <Tag color="blue">
                    {type.replaceAll("_", " ")}
                </Tag>
            ),
        },

        {
            title: "Credit",
            width: 120,
            fixed: "center",
            render: (_, record) =>
                record.entryType === "CREDIT" ? (
                    <Text strong style={{ color: "#52c41a" }}>
                        + ₹ {record.amount.toLocaleString()}
                    </Text>
                ) : (
                    "-"
                ),
        },

        {
            title: "Debit",
            width: 120,
            fixed: "center",
            render: (_, record) =>
                record.entryType === "DEBIT" ? (
                    <Text strong style={{ color: "#ff4d4f" }}>
                        - ₹ {record.amount.toLocaleString()}
                    </Text>
                ) : (
                    "-"
                ),
        },

        {
            title: "Balance",
            dataIndex: "closingBalance",
            width: 120,
            fixed: "center",
            render: (bal) => (
                <Text strong>
                    ₹ {bal.toLocaleString()}
                </Text>
            ),
        },

        {
            title: "Status",
            dataIndex: "status",
            width: 90,
            render: (status) => {
                let color = "default";

                if (status === "SUCCESS") color = "green";
                if (status === "FAILED") color = "red";
                if (status === "PENDING") color = "orange";
                if (status === "REVERSED") color = "purple";

                return <Tag color={color}>{status}</Tag>;
            },
        },

        {
            title: "Date & Time",
            dataIndex: "createdAt",
            width: 180,
            render: (date) =>
                dayjs(date).format("DD MMM YYYY hh:mm A"),
        },

        {
            title: "Remarks",
            dataIndex: "manualRemarks",
            width: 220,
            // ellipsis: true,
            render: (_, record) =>
                record.manualRemarks || record.autoRemarks,
        },

        {
            title: "Action",
            width: 100,
            fixed: "center",
            render: (_, record) => (
                <Button
                    // type="link"
                    variant="outline"
                    size="xs"
                    onClick={() => {
                        setSelectedLedger(record);
                        setLedgerDrawer(true);
                    }}
                >
                    View
                </Button>
            ),
        },
    ];

    useEffect(() => {
        const fetchuserledger = async () => {

            try {
                const data = await Get_user_ledger(
                    dateRange[0].format("YYYY-MM-DD"),
                    dateRange[1].format("YYYY-MM-DD")
                );

                if (data.success) {
                   //console.log(data);
                    setallLedgerReq(data?.userLedger);
                    setLedgerreq(data?.userLedger);
                }
            } catch (error) {

                message.error(
                    error.response?.data?.message ||
                    "Something went wrong."
                );
            } finally {
                setledgerloading(false);
            }

        }
        if (user) {
            fetchuserledger();
        }

    }, [user, dateRange]);
    return (
        <>
            <Topnavbar Headername={Headername} />
            <Container size={'xl'} mt={'sm'}>
                <Title c={'dimmed'}>Ledger</Title>
                <Text size="xs">Verify your entry in ledger</Text>
            </Container>

            <Container size={'lg'} mt={'lg'}>
                <Card title="Ledger History" style={{
                    width: "100%",
                }}>
                    <Row gutter={[16, 16]} style={{ marginBottom: 20 }}>
                        <Col xs={24} md={8}>
                            <RangePicker
                                style={{ width: "100%" }}
                                value={dateRange}
                                onChange={(value) => setDateRange(value)}
                                allowClear={false}
                            />
                        </Col>
                        <Col xs={24} md={4}>
                            <Select
                                value={transactionType}
                                onChange={setTransactionType}
                                style={{ width: "100%" }}
                                options={[
                                    { label: "ALL", value: "ALL" },
                                    { label: "TOP IN", value: "TOPIN" },
                                    { label: "SELF TOP IN", value: "SELF_TOPIN" },
                                    { label: "WALLET TO WALLET", value: "WALLET_TO_WALLET" },
                                    { label: "PAYOUT", value: "PAYOUT" },
                                    { label: "REFUND", value: "REFUND" },
                                    { label: "REVERT", value: "REVERT" },
                                ]}
                            />
                        </Col>
                        <Col xs={24} md={4}>
                            <Select
                                value={status}
                                onChange={setStatus}
                                style={{ width: "100%" }}
                                options={[
                                    { label: "ALL", value: "ALL" },
                                    { label: "CREDIT", value: "CREDIT" },
                                    { label: "DEBIT", value: "DEBIT" },
                                ]}
                            />
                        </Col>

                        <Col xs={24} md={6}>
                            <Search
                                placeholder="Search TXN ID"
                                allowClear
                                value={searchTxn}
                                onChange={(e) => setSearchTxn(e.target.value)}
                                onSearch={handleSearch}
                            />
                        </Col>

                        <Col xs={24} md={6}>
                            <Space>
                                <Button
                                    type="primary"
                                    onClick={handleSearch}
                                >
                                    Search
                                </Button>

                                <Button
                                    onClick={handleReset}
                                    variant="light"
                                >
                                    Reset
                                </Button>
                                <Button type="secondary" variant="outline">
                                    Download
                                </Button>
                                <Button type="secondary" variant="outline" onClick={fetchuserledger}>
                                    Refresh
                                </Button>
                            </Space>
                        </Col>
                    </Row>

                    <div style={{ width: "100%", overflowX: "auto" }}>
                        <Table
                            columns={columns}
                            dataSource={ledgerReq}
                            loading={ledgerloading}
                            bordered
                            size="middle"
                            rowKey="_id"
                            pagination={{
                                pageSize: 10,
                                showSizeChanger: true,
                            }}
                        // scroll={{ x: 1200 }}
                        />
                    </div>
                </Card>
            </Container>

            <Drawer
                title="Ledger Details"
                width={700}
                opened={ledgerDrawer}
                onClose={() => setLedgerDrawer(false)}
            >
                {selectedLedger && (
                    <>
                        <Descriptions
                            bordered
                            size="small"
                            column={1}
                        >
                            <Descriptions.Item label="Transaction ID">
                                {selectedLedger.transactionId}
                            </Descriptions.Item>

                            <Descriptions.Item label="Transaction Type">
                                {selectedLedger.transactionType}
                            </Descriptions.Item>

                            <Descriptions.Item label="Status">
                                <Tag color="green">
                                    {selectedLedger.status}
                                </Tag>
                            </Descriptions.Item>

                            <Descriptions.Item label="Entry Type">
                                <Tag
                                    color={
                                        selectedLedger.entryType === "CREDIT"
                                            ? "green"
                                            : "red"
                                    }
                                >
                                    {selectedLedger.entryType}
                                </Tag>
                            </Descriptions.Item>

                            <Descriptions.Item label="Amount">
                                ₹ {selectedLedger.amount}
                            </Descriptions.Item>

                            <Descriptions.Item label="Fee">
                                ₹ {selectedLedger.fee}
                            </Descriptions.Item>

                            <Descriptions.Item label="GST">
                                ₹ {selectedLedger.gst}
                            </Descriptions.Item>

                            <Descriptions.Item label="TDS">
                                ₹ {selectedLedger.tds}
                            </Descriptions.Item>

                            <Descriptions.Item label="Net Amount">
                                ₹ {selectedLedger.netAmount}
                            </Descriptions.Item>

                            <Descriptions.Item label="Opening Balance">
                                ₹ {selectedLedger.openingBalance}
                            </Descriptions.Item>

                            <Descriptions.Item label="Closing Balance">
                                ₹ {selectedLedger.closingBalance}
                            </Descriptions.Item>

                            <Descriptions.Item label="Auto Remarks">
                                {selectedLedger.autoRemarks}
                            </Descriptions.Item>

                            <Descriptions.Item label="User Remarks">
                                {selectedLedger.manualRemarks || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="Created">
                                {dayjs(selectedLedger.createdAt).format(
                                    "DD MMM YYYY hh:mm:ss A"
                                )}
                            </Descriptions.Item>
                        </Descriptions>

                        <Divider />

                        <Descriptions
                            title="Transaction Details"
                            bordered
                            column={1}
                            size="small"
                        >
                            <Descriptions.Item label="From User">
                                {selectedLedger.transactionDetails?.fromUserCode || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="To User">
                                {selectedLedger.transactionDetails?.toUserCode || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="Reference">
                                {selectedLedger.transactionDetails?.referenceNumber || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="Bank Reference">
                                {selectedLedger.transactionDetails?.bankReference || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="API Reference">
                                {selectedLedger.transactionDetails?.apiReference || "-"}
                            </Descriptions.Item>
                        </Descriptions>

                        <Divider />

                        <Descriptions
                            title="Additional Information"
                            bordered
                            column={1}
                            size="small"
                        >
                            {selectedLedger.displayMetaData?.length > 0 ? (
                                selectedLedger.displayMetaData.map((item) => (
                                    <Descriptions.Item
                                        key={item._id}
                                        label={item.label}
                                    >
                                        {item.value || "-"}
                                    </Descriptions.Item>
                                ))
                            ) : (
                                <Descriptions.Item label="Info">
                                    No Additional Information
                                </Descriptions.Item>
                            )}
                        </Descriptions>
                    </>
                )}
            </Drawer>
        </>
    )
}
export default Adminselfledger;